import { DATA_STATES } from '@/store/consts';
import { DEFAULT_CONFIGURATION_STEPS, WIDGETS_CONFIGURATION, CONNECTION_TEST_RESULT_STATE } from './helper';
import { widgetService } from '../../../../services/widget/WidgetService';

const STATE_KEYS = {
  CURRENT_WIDGET_ID: 'currentWidgetId',
  CURRENT_SERVICE: 'currentService',
  DATA_STATE: 'dataState',
  WIDGETS: 'widgets',
  LAST_UPDATE_TIME: 'lastUpdateTime',
  ERROR_COUNT: 'errorCount',
  CONFIGURATION_STEP_IDX: 'configurationStepIndex',
  ALL_CONFIGURATION_STEPS: 'allConfigurationSteps',
  WIDGET_CONNECTION: 'widgetConnection',
  WIDGET_CUSTOMIZATION: 'widgetCustomization',
  WIDGET_VIEW: 'widgetView',
  WIDGET_LAYOUT: 'widgetLayout',
  WIDGETS_CONFIGURATION: 'widgetsConfiguration',
  CONNECTION_TEST_RESULT: 'widgetConnectionTestResult',
  DELETE_RESPONSE: 'widgetDeleteConnectionResponse',
  EXPLORER_RESPONSE: 'widgetExplorerResponse',
};

const state = {
  [STATE_KEYS.CURRENT_WIDGET_ID]: null,
  [STATE_KEYS.CURRENT_SERVICE]: widgetService,

  [STATE_KEYS.DATA_STATE]: DATA_STATES.NONE,
  [STATE_KEYS.WIDGETS]: [],
  [STATE_KEYS.LAST_UPDATE_TIME]: null,
  [STATE_KEYS.ERROR_COUNT]: 0,

  [STATE_KEYS.CONFIGURATION_STEP_IDX]: 0,
  [STATE_KEYS.LAST_UPDATE_TIME]: null,
  [STATE_KEYS.ALL_CONFIGURATION_STEPS]: DEFAULT_CONFIGURATION_STEPS,
  [STATE_KEYS.WIDGET_CONNECTION]: null,
  [STATE_KEYS.WIDGET_CUSTOMIZATION]: null,
  [STATE_KEYS.WIDGET_VIEW]: {},
  [STATE_KEYS.WIDGET_LAYOUT]: {},
  [STATE_KEYS.WIDGETS_CONFIGURATION]: WIDGETS_CONFIGURATION,
  [STATE_KEYS.CONNECTION_TEST_RESULT]: CONNECTION_TEST_RESULT_STATE.NONE,
  [STATE_KEYS.DELETE_RESPONSE]: null,
  [STATE_KEYS.EXPLORER_RESPONSE]: null,
};

export {
  state,
  STATE_KEYS,
};
